// @vendor
import React, { Component } from 'react';
import { connect } from 'react-redux';

// @components
import OkModalOnboarding from 'components/commons/OkModalOnboarding/OkModalOnboarding';
import OnlineValidationModal from 'components/newIdentifyMethods/Iban/OnlineValidationModal';

// @actions
import { startPolling, stopPolling } from 'actions/polling';

// @ constants
import { WAITING_STATUS, FAILED_STATUS, SUCCESS_STATUS, ASNEF_ERROR } from 'constants/pollingConstants';
import { goToErrorsView } from 'actions/errorViewNavigation';

function withPollingModalFeature(WrappedComponent) {
    class BaseWithPoolingFeature extends Component {
        state = {
            showModal: false,
            activeModal: '',
            isLastRequest: false,
        };

        componentWillUnmount() {
            const { stopPolling } = this.props;
            stopPolling();
        }

        startPollingWith = (callbackOptions, withWaitingModal) => {
            const { startPolling } = this.props;
            if (withWaitingModal) this.onHandleModal(true, WAITING_STATUS);
            startPolling(callbackOptions);
        };

        onHandleModal = (open, activeModal) => this.setState({ activeModal, showModal: open });

        onHandleAceptOrClosePollingModal = callback => {
            this.onHandleModal(false, WAITING_STATUS);
            callback();
        };

        onHandleFinishPolling = status => {
            switch (status) {
                case FAILED_STATUS:
                    this.onHandleModal(true, FAILED_STATUS);
                    break;
                case SUCCESS_STATUS:
                    this.onHandleModal(true, SUCCESS_STATUS);
                    break;
                case ASNEF_ERROR:
                    this.onHandleModal(true, FAILED_STATUS);
                    setTimeout(() => this.props.goToErrorsView({ errorMessage: ASNEF_ERROR }), 1000);
                    break;
                default:
                    break;
            }
        };

        returnBodyModal = (activeModal, userProfile, modalOptions) => {
            switch (activeModal) {
                case FAILED_STATUS:
                    return {
                        content: (
                            <OnlineValidationModal
                                userProfile={userProfile}
                                icon={modalOptions.icon}
                                body={modalOptions.body}
                                head={modalOptions.head}
                                buttonText={modalOptions.buttonText}
                                withButton={true}
                                onAccept={() => this.onHandleAceptOrClosePollingModal(modalOptions.onAccept)}
                            />
                        ),
                        onClose: () => this.onHandleAceptOrClosePollingModal(modalOptions.onClose),
                        displayHeaderCloseIcon: true,
                    };
                case SUCCESS_STATUS:
                    return {
                        content: (
                            <OnlineValidationModal
                                userProfile={userProfile}
                                icon={modalOptions.icon}
                                head={modalOptions.head}
                                buttonText={modalOptions.buttonText}
                                withButton={true}
                            />
                        ),
                        onClose: () => this.onHandleAceptOrClosePollingModal(modalOptions.onClose),
                        displayHeaderCloseIcon: true,
                    };
                default:
                    return {
                        content: (
                            <OnlineValidationModal
                                userProfile={userProfile}
                                icon={modalOptions.icon}
                                body={modalOptions.body}
                                head={modalOptions.head}
                                withButton={false}
                            />
                        ),
                        onClose: () => this.onHandleAceptOrClosePollingModal(modalOptions.onClose),
                        displayHeaderCloseIcon: false,
                    };
            }
        };

        setModalContent = modalContent => this.setState({ modalContent });

        renderPollingModal = (userProfile, modalOptions) => {
            const { activeModal, showModal } = this.state;
            const { content, onClose, displayHeaderCloseIcon } = this.returnBodyModal(
                activeModal,
                userProfile,
                modalOptions
            );

            return (
                <OkModalOnboarding
                    headerCloseIcon={displayHeaderCloseIcon}
                    onClose={onClose}
                    modalIsOpen={showModal}
                    className="video-screen__modal-content"
                >
                    {content}
                </OkModalOnboarding>
            );
        };

        render = () => {
            return (
                <WrappedComponent
                    {...this.props}
                    handleSetPollingModal={this.onHandleModal}
                    renderPollingModal={this.renderPollingModal}
                    handleModalOnPollFinished={this.onHandleFinishPolling}
                    startPollingWith={this.startPollingWith}
                />
            );
        };
    }

    return connect(
        state => ({
            polling: state.polling,
            userProfile: state.userProfile,
            options: state.options,
            video: state.video,
        }),
        {
            startPolling,
            stopPolling,
            goToErrorsView,
        }
    )(BaseWithPoolingFeature);
}

export default withPollingModalFeature;
